import { render, staticRenderFns } from "./playDialog.vue?vue&type=template&id=3465baf5&"
import script from "./playDialog.vue?vue&type=script&lang=js&"
export * from "./playDialog.vue?vue&type=script&lang=js&"
import style0 from "./playDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports